export default __webpack_public_path__ + "static/media/firefighter.75e1e28a.png";